export const communication = {
    accept : "J'ai bien lu, ne plus afficher ce message."
}
